import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { number, array } from 'prop-types';
import { startSetDashboardSummary } from '../../actions/dashboard';
import Card from '../../components/Card/Card';
import { formatToCurrency } from '../../utils/utils';

class SummaryWidget extends Component {
  static propTypes = {
    leads: number.isRequired,
    sum: array.isRequired,
  };

  static defaultProps = {
    leads: 0,
    sum: [],
  };

  componentDidMount() {
    this.props.startSetDashboardSummary();
  }

  render() {
    const { leads, sum, currencies, collapsing, localStorageName } = this.props;
    return (
      <Card localStorageName={localStorageName} collapsing={collapsing}>
        <Card.Header>
          <FormattedMessage id="widgets.summary.title" defaultMessage="Summary for today" />
        </Card.Header>
        <Card.Body className="no-padding">
          <table className="summary-table">
            <tbody>
              <tr>
                <td className="summary-table-conversions">
                  <FormattedMessage id="widgets.summary.conversions" defaultMessage="Conversions" />
                </td>
                <td className="summary-table-earned">{leads}</td>
              </tr>
            </tbody>
          </table>
        </Card.Body>
        <Card.Body className="no-padding">
          <table className="summary-table">
            <thead>
              <tr>
                <th className="summary-table-earned">
                  <FormattedMessage id="widgets.summary.earned" defaultMessage="You've earned" />
                </th>
                <th className="summary-table-earned">
                  <b>{formatToCurrency(sum?.[0] || 0)} ₽</b>
                </th>
              </tr>
            </thead>
          </table>
        </Card.Body>
      </Card>
    );
  }
}

const mapStateToProps = ({ dashboard, app }) => ({
  sum: dashboard.sum,
  leads: dashboard.leads,
  currencies: app.globalSettings.currencies,
});

const mapDispatchToProps = (dispatch) => ({
  startSetDashboardSummary: () => dispatch(startSetDashboardSummary()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SummaryWidget);
